import { render, staticRenderFns } from "./EDialogTips.vue?vue&type=template&id=73fdefeb&scoped=true"
import script from "./EDialogTips.vue?vue&type=script&lang=js"
export * from "./EDialogTips.vue?vue&type=script&lang=js"
import style0 from "./EDialogTips.vue?vue&type=style&index=0&id=73fdefeb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29728efa34f7641bbb3742d4a0c0d7ae/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fdefeb",
  null
  
)

export default component.exports